import {
  InputField,
  IStyles,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import {
  Box,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Typography,
  Radio,
  Select,
  MenuItem,
} from '@mui/material';
import { ToggleSwitch } from 'libs/shared-ui/src/components/elements/ToggleSwitch';

const styles: IStyles = {
  rootBox: {
    marginBottom: { xs: pxToRem(20), md: pxTovW(20) },
  },
  toggleRadioBox: {
    display: 'flex',
    gap: { xs: pxToRem(10), md: pxTovW(50) },
    alignItems: { xs: 'flex-start', md: 'center' },
    flexDirection: { xs: 'column', md: 'row' },
  },
  toggleBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    boxSizing: 'border-box',
  },
  labelTypo: {
    fontSize: { xs: pxToRem(20), md: pxTovW(25), lg: pxTovW(18) },
  },
  formControl: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  timeBox: {
    marginTop: { xs: pxToRem(20), md: pxTovW(30) },
  },
  timeInputBox: {
    display: 'flex',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
};

interface IClickerTimedToggleProps {
  toggleChecked: boolean;
  handleToggleChange: () => void;
  clickerTimedType: 'default' | 'custom';
  handleClickerTimedType: (type: 'default' | 'custom') => void;
  // selectedValue: { minutes: number; seconds: number };
  // handleSelectedValueChange: (value: { minutes: number; seconds: number }) => void;
  selectedPreDefinedTime: string;
  handleSelectedPreDefinedTimeChange: (value: string) => void;
  customDefinedTime: { minutes: number; seconds: number };
  handleCustomDefinedTimeChange: (value: {
    minutes: number;
    seconds: number;
  }) => void;
}
export const ClickerTimedToggle = (props: IClickerTimedToggleProps) => {
  const {
    toggleChecked,
    handleToggleChange,
    clickerTimedType,
    handleClickerTimedType,
    selectedPreDefinedTime,
    handleSelectedPreDefinedTimeChange,
    customDefinedTime,
    handleCustomDefinedTimeChange,
  } = props;
  const PRE_DEFINED_TIME = [
    { id: 1, name: '30 seconds' },
    { id: 2, name: '1 minute' },
    { id: 3, name: '2 minutes' },
    { id: 4, name: '3 minutes' },
    { id: 5, name: '4 minutes' },
    { id: 6, name: '5 minutes' },
  ];

  return (
    <Box sx={styles.rootBox}>
      <Box sx={styles.toggleRadioBox}>
        <Box sx={styles.toggleBox}>
          <Typography variant="h3" sx={styles.labelTypo}>
            Timer at question level
          </Typography>

          <ToggleSwitch
            checked={toggleChecked}
            handleChange={handleToggleChange}
          />
        </Box>

        {toggleChecked && (
          <FormControl sx={styles.formControl}>
            <RadioGroup
              row
              aria-labelledby="choose-state-radio-group-label"
              name="choose-state-radio-group"
              sx={{ display: 'flex' }}
            >
              <FormControlLabel
                value={'Default Timer'}
                control={
                  <Radio
                    checked={clickerTimedType === 'default'}
                    onClick={() => handleClickerTimedType('default')}
                  />
                }
                label={
                  <Typography
                    variant="h2"
                    sx={{
                      color:
                        clickerTimedType === 'default' ? '#007CDC' : '#000',
                      fontSize: { xs: pxToRem(18), md: pxTovW(21) },
                    }}
                  >
                    Default Timer
                  </Typography>
                }
              />

              <FormControlLabel
                value={'Custom Timer'}
                control={
                  <Radio
                    checked={clickerTimedType === 'custom'}
                    onClick={() => handleClickerTimedType('custom')}
                  />
                }
                label={
                  <Typography
                    variant="h2"
                    sx={{
                      color: clickerTimedType === 'custom' ? '#007CDC' : '#000',
                      fontSize: { xs: pxToRem(18), md: pxTovW(21) },
                    }}
                  >
                    Custom Timer
                  </Typography>
                }
              />
            </RadioGroup>
          </FormControl>
        )}
      </Box>

      {toggleChecked && (
        <Box sx={styles.timeBox}>
          {clickerTimedType === 'default' ? (
            <Select
              value={selectedPreDefinedTime}
              onChange={(e) => {
                handleSelectedPreDefinedTimeChange(e.target.value);
              }}
              displayEmpty
              sx={{
                background: '#F5FAFF',
                width: { xs: '100%', md: pxTovW(332) },
                borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
                height: { xs: 'max-content', md: '70%', lg: pxTovW(65) },
                '.MuiOutlinedInput-notchedOutline': { borderColor: '#007CDC' },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#007CDC',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#007CDC',
                },
                boxShadow: 'none',
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                    minHeight: { xs: 'max-content', md: 'max-content' },
                    backgroundColor: '#F8FCFF',
                    '&::-webkit-scrollbar': { display: 'none' },
                    padding: 0,
                    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
                    '& .MuiList-root': {
                      backgroundColor: '#F8FCFF',
                      maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                      padding: 0,
                    },
                    scrollbarWidth: 'thin',
                    minWidth: { xs: '95%', md: pxTovW(230) },
                    maxWidth: { xs: '95%', md: pxTovW(200), lg: pxTovW(150) },
                  },
                },
              }}
            >
              {PRE_DEFINED_TIME.map((option) => (
                <MenuItem key={option.id} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          ) : (
            <Box sx={styles.timeInputBox}>
              <LocalInputBox
                label="Minutes"
                value={customDefinedTime.minutes.toString()}
                onChange={(value) => {
                  // Clamp minutes to 0-20 range, then adjust seconds accordingly
                  // (if minutes >= 20, force seconds to 0; if minutes = 0 and seconds < 30, set seconds to 30)
                  const parsed = Number.parseInt(value, 10);
                  const nextMinutes = Number.isNaN(parsed) ? 0 : parsed;
                  const clampedMinutes = Math.min(Math.max(nextMinutes, 0), 20);

                  let nextSeconds = customDefinedTime.seconds;
                  if (clampedMinutes >= 20) {
                    nextSeconds = 0;
                  } else if (clampedMinutes === 0 && nextSeconds < 30) {
                    nextSeconds = 30;
                  }

                  handleCustomDefinedTimeChange({
                    minutes: clampedMinutes,
                    seconds: nextSeconds,
                  });
                }}
              />

              <LocalInputBox
                label="Seconds"
                value={customDefinedTime.seconds.toString()}
                onChange={(value) => {
                  // Allow free typing - only enforce basic constraints during typing
                  // if minutes >= 20 force seconds to 0,
                  // otherwise clamp to 0-59 range (don't enforce 30-second minimum during typing)
                  const parsed = Number.parseInt(value, 10);
                  let nextSeconds = Number.isNaN(parsed) ? 0 : parsed;

                  if (customDefinedTime.minutes >= 20) {
                    nextSeconds = 0;
                  } else {
                    nextSeconds = Math.min(Math.max(nextSeconds, 0), 59);
                    // Don't enforce 30-second minimum here - allow user to type freely
                  }

                  handleCustomDefinedTimeChange({
                    ...customDefinedTime,
                    seconds: nextSeconds,
                  });
                }}
                onBlur={() => {
                  // Enforce 30-second minimum when user finishes editing (on blur)
                  if (
                    customDefinedTime.minutes === 0 &&
                    customDefinedTime.seconds < 30
                  ) {
                    handleCustomDefinedTimeChange({
                      ...customDefinedTime,
                      seconds: 30,
                    });
                  }
                }}
              />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

// =====================================================================

const LocalInputBox = ({
  label,
  value,
  onChange,
  onBlur,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: pxToRem(10), md: pxTovW(10) },
        flexGrow: { xs: '1', md: '0' },
      }}
    >
      <Typography variant="h3" sx={styles.labelTypo}>
        {label}
      </Typography>

      <InputField
        value={value}
        name={label}
        onWheel={(e) => {
          e.preventDefault();
          (e.target as HTMLElement).blur();
        }}
        inputProps={{
          min: 0,
          inputMode: 'numeric',
        }}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        variant="outlined"
        nonCircular
        type="number"
        autoComplete="off"
        onKeyDown={(evt) => {
          let checkIfNum = false;
          if (evt.key !== undefined) {
            checkIfNum =
              evt.key === 'e' ||
              evt.key === '.' ||
              evt.key === '+' ||
              evt.key === 'ArrowUp' ||
              evt.key === 'ArrowDown';
          }
          return checkIfNum && evt.preventDefault();
        }}
        sx={{
          borderRadius: { xs: pxToRem(0.8), md: pxTovW(0.8) },
          '& input[type=number]': {
            '-moz-appearance': 'textfield',
            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
              '-webkit-appearance': 'none',
              margin: 0,
            },
          },
        }}
      />
    </Box>
  );
};

// =====================================================================
